import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-footer',
  template: '<footer class="bg-light text-center p-3 mt-5"><small>&copy; 2025 Gobierno de Chile</small></footer>'
})
export class FooterComponent {}